import { gql } from '@apollo/client'

export const DOCUMENT_SIGNATURE_ATTRIBUTES = gql`
  fragment documentSignatureAttributes on DocumentSignature {
    id
    createdAt
    signatureUrl
    builderGenerated
    worker {
      id
      user {
        firstName
        lastName
        email
      }
    }
    adminUser {
      id
      user {
        firstName
        lastName
      }
    }
    induction {
      id
      type
      templateName
    }
    swmsDoc {
      id
      name
      subcontractorId
      projectId
      project {
        id
        name
      }
      showAll
    }
  }
`

export const GET_SIGNATURE_UPLOAD_URL = gql`
  query getPresignedUrlForSignature_UI(
    $id: String!
    $filename: String!
    $filesize: String!
    $filetype: String!
  ) {
    getPresignedUrl(
      input: {
        id: $id
        type: SIGNATURE
        filename: $filename
        filesize: $filesize
        filetype: $filetype
      }
    ) {
      url
      key
      viewUrl
    }
  }
`

export const CREATE_DOCUMENT_SIGNATURE_FOR_WORKER = gql`
  mutation createDocumentSignatureForWorker_UI(
    $input: CreateDocumentSignatureForWorkerInput!
  ) {
    createDocumentSignatureForWorker(input: $input) {
      ...documentSignatureAttributes
    }
  }
  ${DOCUMENT_SIGNATURE_ATTRIBUTES}
`
